import React, { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { getOptionsData } from "../../utils/app.utils";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@mui/material";

export default function RadioButton({ question, value, onChange }: any) {
  const [selected, setSelected] = useState(value ?? "");
  const [options, setOptions] = useState<any[]>([]);

  const { data: optionsData = [], isLoading } = useQuery({
    queryKey: ["options", question?.id],
    queryFn: () => getOptionsData(question?.id),
  });

  useEffect(() => {
    if (optionsData.length) {
      setOptions(optionsData);
    }
  }, [optionsData]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelected(event.target.value);
    onChange?.(event.target.value);
  };

  return (
    <FormControl component="fieldset" sx={{ mt: 1 }}>
      <RadioGroup
        name={`radio_${question.id}`}
        value={selected}
        onChange={handleChange}
        row
      >
        {options.map((opt: any) => (
          <FormControlLabel
            key={opt.id}
            value={opt.id.toString()}
            control={<Radio />}
            label={opt.short_name || opt.name}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
}
